export interface ReceiptReviewDraft {
  user_id: string | number;
  vendor: string;
  vendor_address: string;
  date: string;
  sub_total_amount: string | number;
  tax_amount: string | number;
  total_amount: string | number;
  currency: string;
  expense_type: string | number;
  notes: string;
}

export type ReceiptReviewErrors = Partial<Record<keyof ReceiptReviewDraft, string | null>>;

export interface ConfidenceField {
  confidence?: number | null;
}

export type ReceiptConfidenceFields = Record<string, ConfidenceField>;

export const receiptFieldClass =
  "mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500";
